import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Directive, ElementRef, forwardRef, HostListener, inject, OnInit } from '@angular/core';

@Directive({
  selector:
    // eslint-disable-next-line @angular-eslint/directive-selector
    '[contenteditable][formControl]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContenteditableAccessor),
      multi: true,
    },
  ],
})
export class ContenteditableAccessor implements ControlValueAccessor, OnInit {
  private readonly eltRef = inject(ElementRef);

  private onChange: (value: string) => void = () => undefined;
  private onTouched: () => void = () => undefined;

  ngOnInit() {
    this.onChange(this.eltRef.nativeElement.innerText);
  }

  writeValue(value: string): void {
    this.eltRef.nativeElement.innerText = value;
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  @HostListener('input')
  handleInput() {
    this.onChange(this.eltRef.nativeElement.innerText);
  }
}
